//
// Reusable/default header that renders StepHeader with a back button
//
import React, { Fragment } from 'react'

import { ResponsiveSVG } from 'ui/acro'
import { Flex, StepHeader, CTA, Button } from 'ui/chandra'
import { LeftArrow } from 'images'
import styled from 'styled-components'

import { useSurveyContext } from '../../_store'

const Header00 = ({ step }) => {
  const { state, actions } = useSurveyContext()

  const StyledCTA = styled(CTA)`
    color: #636363;
    margin-bottom: 5px;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.396px;
  `

  const StepHeaderContainer = styled(StepHeader)`
    @media all and (max-width: 1024px) {
      margin-top: null;
    }
  `

  const ArrowContainer = styled(Button)`
    min-width: 18px;
    min-height: 18px;
    background: none;
    border: none;
  `

  const { bonus, visualStep, numSteps, title, subtitle } =
    state.pages[`step_${step}`].page

  const headerStep = (
    <Flex id='survey_header'>
      {step > 1 && (
        <ArrowContainer
          id='survey_header_back_btn'
          type='link'
          onClick={() => actions.back(step)}
          className='unstyled'
        >
          <ResponsiveSVG
            SVG={LeftArrow}
            width={['18px']}
            height={['18px']}
            mr={['12px', null, '14px']}
            fill='primary'
          />
        </ArrowContainer>
      )}
      <StyledCTA>
        {bonus ? 'Bonus Question' : `Question ${visualStep} of ${numSteps}`}
      </StyledCTA>
    </Flex>
  )

  const headerBody = (
    // REACT_TODO: Have API send subtitle as Markdown for the client to process, e.g. **text**
    <span dangerouslySetInnerHTML={{ __html: subtitle }} />
  )

  //////////////////////////////////////////////////

  return (
    <Fragment>
      <StepHeaderContainer step={headerStep} title={title} body={headerBody} />
    </Fragment>
  )
}

export default Header00
